jQuery(function ($) {
    $(document).ready(function () {
        if ($('.from-our-founder-read-more-container').length > 0) {
            $('.from-our-founder-read-more-container button').on('click', function () {
                const content = $('.from-our-founder-read-more-container > div');
                const button = $('.from-our-founder-read-more-container button');

                if (content.hasClass('overflow-hidden')) {
                    content.removeClass('overflow-hidden').addClass('overflow-y-auto');
                    button.text(button.data('text-show-less'));
                } else {
                    content.scrollTop(0);
                    content.addClass('overflow-hidden').removeClass('overflow-y-auto');
                    button.text(button.data('text-read-more'));
                }
            });
        }
    });
});